import { Autocomplete, CircularProgress, FormControl, TextField } from "@mui/material";
import { observer } from "mobx-react-lite";
import { RBDType } from "../../app/config/enum";
import { ISystem } from "../../app/models/asset";
import { useStore } from "../../app/stores/store";

interface Props {
    disabled: boolean;
}

function RBDSettingSystem({ disabled }: Props) {
    const { rbdStore } = useStore();

    const handleChange = (value: ISystem | null) => {
        rbdStore.setSelectedSystem(value)
    }

    return (
        <FormControl fullWidth sx={{ mb: 4 }}>
            <Autocomplete
                readOnly={rbdStore.selectedRbdType === RBDType.SYSTEM}
                options={rbdStore.dropdownSystem}
                renderInput={(params) =>
                    <TextField {...params} disabled={disabled} label="System" InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {rbdStore.loadingSystem ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }} />
                }
                getOptionDisabled={(option) => (
                    rbdStore.selectedRbdType === RBDType.STATION &&
                    rbdStore.rbdItems.map(x => x.element?.systemId).indexOf(option.id) >= 0
                )}
                getOptionLabel={(system) => system.name}
                renderOption={(props, option) =>
                    <li {...props} key={option.id}>
                        {option.name}
                    </li>
                }
                value={rbdStore.selectedSystem}
                onChange={(e, val) => handleChange(val)}
                loading={rbdStore.loadingSystem}
            />
        </FormControl>
    );
}

export default observer(RBDSettingSystem);